import esLocale from 'date-fns/locale/es';

// Material UI
import { Grid, Alert } from '@mui/material';
import { MobileDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

// Componentes
import TextFieldTK from '@components/Form/TextFieldTK';

// Utils
import { isNullOrUndefined } from '@utils/validations';

const SesionesEventos = (props) => {
  const { isLoading, formik, initial, disabledDates } = props;

  const handleChange = (index, value) => {
    let FechaFin = formik.values.FechaFin;

    const updated = [...formik.values.sesiones];
    updated[index] = isNullOrUndefined(value) ? '' : value;

    if (updated.length - 1 === index) FechaFin = updated[index];

    formik.setValues({ ...formik.values, sesiones: updated, FechaFin });
  };

  const getFormik = (index, type = 'errors') => {
    if (formik.touched?.sesiones !== undefined) {
      const sesion = formik?.[type]?.sesiones;
      if (sesion?.length > 0 && sesion[index]) return sesion[index];
      return '';
    }
  };

  const getStriped = (index) => ({ background: index % 2 ? '#E4ECFA' : 'white' });

  return (
    <Grid container spacing={2}>
      {disabledDates?.length > 0 && (
        <Grid item xs={12}>
          <Alert variant="outlined" severity="info" sx={{ borderColor: 'info.main', mb: 1 }}>
            No puedes editar sesiones que ya tengan asistencias
          </Alert>
        </Grid>
      )}

      {formik.values.sesiones.map((sesion, index) => {
        const item = initial?.[index] || null;
        const invalid = item ? new Date(item) < new Date() : false;
        const haveAttendence = item ? disabledDates.includes(item?.split(' ')?.[0]) : false;

        const disabled = isLoading || index === 0 || invalid || haveAttendence;

        return (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
              <MobileDateTimePicker
                label={`Sesión ${index + 1}*`}
                value={sesion}
                onChange={(value) => handleChange(index, value)}
                minDate={index > 0 ? formik.values.sesiones?.[index - 1] : null}
                maxDate={index > 0 ? formik.values.sesiones?.[index + 1] || null : null}
                disabled={disabled}
                renderInput={(params) => (
                  <TextFieldTK
                    {...params}
                    fullWidth
                    disabled={disabled}
                    sx={getStriped(index)}
                    error={Boolean(getFormik(index))}
                    helperText={getFormik(index)}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default SesionesEventos;
